import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request } from "../apiV2Request";
import { trpc } from "../trpc";

export const useAdminFeatureFlagBusinessDisable = (featureFlagId: number) => {
  const queryClient = useQueryClient();
  const trpcUtils = trpc.useUtils();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `feature-flags/${featureFlagId}/business/${business?.id}`,
      }),
    onSuccess: () =>
      Promise.all([
        trpcUtils.featureFlag.list.invalidate(),
        queryClient.invalidateQueries({
          queryKey: ["feature-flags", "admin", business?.id],
        }),
      ]),
  });
};
